import { registerClickHandler } from '@/js/utils/eventDelegation.js';
import Plugin from '@/js/vue/drawer-menu/plugin.js';

/**
 * ドロワーメニューのトグルハンドラを登録
 *
 * 統一されたイベント委譲システムを使用
 * Vue化したDrawerMenuプラグイン経由で制御
 */

export function registerDrawerMenuHandler() {
    registerClickHandler({
        selector: 'a[data-drawer_menu]',
        priority: 4, // 優先度を指定可能
        callback: (trigger, event) => {
            event.preventDefault();

            // 未マウントなら何もしない（エラーページ等の保険）
            if (!Plugin.isMounted()) {
                if (import.meta.env.DEV) {
                    console.debug('[DrawerMenu] not mounted, toggle skipped');
                }
                return;
            }

            // プラグイン経由で制御（グローバル汚染なし）
            Plugin.toggle();
        },
    });
}
